import { Injectable } from '@angular/core';
 
@Injectable()
export class CsvService {
    
    tokenDelimeter = ";";
    isHeaderPresentFlag = true;
    valildateFileExtenstionFlag = true;

    constructor() {}
 
    isCSVFile(file: File) {
        return file.name.endsWith(".csv");
    }
 
    getHeaderArray(csvRecordsArr: String[]) {        
        let headers = csvRecordsArr[0].split(this.tokenDelimeter);
        let headerArray = [];
        for (let j = 0; j < headers.length; j++) {
            headerArray.push(headers[j]);
        }
        return headerArray;
    }
 
    validateHeaders(originHeaders: String[], fileHeaders: string[]) {
        if (originHeaders.length != fileHeaders.length) {
            return false;
        }
 
        var fileHeaderMatchFlag = true;
        for (let j = 0; j < originHeaders.length; j++) {
            if (originHeaders[j] != fileHeaders[j]) {
                fileHeaderMatchFlag = false;
                break;
            }
        }
        return fileHeaderMatchFlag;
    }
 
    getDataRecordsArrayFromCSVFile(csvRecordsArray: String[], headerLength: number) {
        var dataArr = []
 
        for (let i = 0; i < csvRecordsArray.length; i++) {
            let data = csvRecordsArray[i].split(this.tokenDelimeter);
            let col = [];
            for (let j = 0; j < data.length; j++) {
                col.push(data[j]);
            }
            dataArr.push(col);
        }   
        return dataArr;
    }
 
}